export class UserData {
    bmAccess: string;
    country: string[];
    feature: string[];
    hmDisplayName: string;
    organization: string;
    organizationId: string;
    organizationType: string;
    preferredUsername: string;
    product: string[];
    sub: string;

    public hasAccess(): boolean {
        if (this.organization.toLocaleLowerCase() === 'housemark') return true;
        if (this.bmAccess.toLowerCase() === 'noaccess') return false;
        if (this.product.includes('residentinvolvementbenchmarking') && !this.product.includes('planform')) return false;

        return true;
    }
}
